import * as React from 'react';



export default class UserNum extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 15 10" fill="none" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <rect x="0.5" y="0.5" width="14" height="9" rx="0.5" stroke="#848484"/>
        <circle cx="4" cy="3" r="1" fill="#C4C4C4"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6 6C6 4.89542 5.10461 4 4 4C2.89539 4 2 4.89542 2 6H6Z" fill="#C4C4C4"/>
        <rect x="8" y="3" width="5" height="1" fill="#C4C4C4"/>
        <rect x="8" y="5" width="5" height="1" fill="#C4C4C4"/>
        <rect x="2" y="7" width="4" height="1" fill="#C4C4C4"/>
        <rect x="8" y="7" width="1" height="1" fill="#C4C4C4"/>
        <rect x="10" y="7" width="1" height="1" fill="#C4C4C4"/>
        <rect x="12" y="7" width="1" height="1" fill="#C4C4C4"/>
      </svg>
    )
  }
}
